import type { NodeProps } from '../../core';

/** Shown for a node whose `type` has no component in `nodeTypes`. */
export const DefaultNode = ({ data }: NodeProps) => (
  <div className="cm-node-default">{typeof data.label === 'string' ? data.label : null}</div>
);
